import enTranslation from "./en.json";

export type translationKeyTypes = keyof typeof enTranslation;

const keys = Object.keys(enTranslation).reduce(
  (acc, curr) => ({ ...acc, [curr]: curr }),
  {}
) as Record<translationKeyTypes, translationKeyTypes>;

export default keys;
